module.exports = "/packs/images/svg/facilities/cafe~705d6579398304e4e9554172e3689e2a.svg";